import React, { useState, useEffect, useRef, useCallback } from "react";

let scriptLoaded = false;

export default function SearchLocationInput ({ apiKey, handler, invalid, }) {
	const [query, setQuery] = useState("");
	const autoCompleteRef = useRef(null);

	const loadScript = (url, callback) => {
		let script = document.createElement("script");
		script.type = "text/javascript";

		if (script.readyState) {
			script.onreadystatechange = function () {
				if (script.readyState === "loaded" || script.readyState === "complete") {
					script.onreadystatechange = null;
					callback();
				}
			};
		} else {
			script.onload = () => callback();
		}

		script.src = url;
		document.getElementsByTagName("head")[0].appendChild(script);
	}

	const handleScriptLoad = useCallback((updateQuery, handler, invalid, autoCompleteRef) => {
		const autoComplete = new window.google.maps.places.Autocomplete(
			autoCompleteRef.current,
			{ types: ["(regions)"], componentRestrictions: { country: "uk" } }
		);

		autoComplete.setFields(["address_components", "formatted_address"]);
		autoComplete.addListener("place_changed", () => {
			handlePlaceSelect(updateQuery, handler, invalid, autoComplete);
		});

		scriptLoaded = true;
	}, []);

	const handlePlaceSelect = async (updateQuery, handler, invalid, autoComplete) => {
		const addressObject = autoComplete.getPlace();

		if (addressObject.name) {
			invalid('notSelected');
			updateQuery('');

			return;
		}

		const query = addressObject.formatted_address,
			postalCode = addressObject.address_components.find(function (component) {
				return component.types[0] == "postal_code";
			});

		updateQuery(query);

		if (typeof postalCode !== 'undefined') {
			handler(postalCode.long_name, query);
		} else {
			invalid('postcode');
		}
	}

	useEffect(() => {
		if (!scriptLoaded) {
			loadScript(
				`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`,
				() => handleScriptLoad(setQuery, handler, invalid, autoCompleteRef)
			);
		}
	}, [apiKey, handleScriptLoad, handler, invalid]);

	return (
		<label className="search-location-input">
			<p>Enter your postcode...</p>
			<input
				type="search"
				name="postcode"
				ref={autoCompleteRef}
				onChange={event => setQuery(event.target.value)}
				placeholder=""
				value={query}
			/>
		</label>
	);
}
